import React, { useState, useEffect } from "react";
import ArticleCard from "./ArticleCard";
import { apiFetch } from "../utils/api";

export default function NewsList({ articles: initialArticles, user }) {
  const [articles, setArticles] = useState(initialArticles || []);

  // Keep state in sync if parent reloads articles
  useEffect(() => {
    setArticles(initialArticles || []);
  }, [initialArticles]);

  if (!articles || articles.length === 0) {
    return (
      <div className="news-list">
        <p className="empty">No additional articles available.</p>
      </div>
    );
  }

  const handleArticleDeleted = async (id) => {
    try {
      const res = await apiFetch(`/articles/${id}`, {
        method: "DELETE",
      });

      if (!res.ok) {
        throw new Error("Delete failed");
      }

      // ✅ Only remove from UI after backend confirms
      setArticles(prev => prev.filter(a => a.id !== id));
    } catch (err) {
      console.error(err);
      alert("Failed to delete article.");
    }
  };

  return (
    <section className="news-list" aria-label="Latest articles">
      <div className="article-grid">
        {articles.map(article => (
          <ArticleCard
            key={article.id}
            article={article}
            user={user}
            onDeleted={handleArticleDeleted}
          />
        ))}
      </div>
    </section>
  );
}
